import React, { useEffect, useState } from "react";
import { GrInstagram } from "react-icons/gr";
import {
	FaUserCheck,
	FaMapMarkedAlt,
	FaTiktok,
	FaPhoneAlt,
} from "react-icons/fa";
import { BiLogoTelegram } from "react-icons/bi";
import { useGlobalStates } from "../context/GlobalProvider";
import { motion, AnimatePresence } from "framer-motion";

const Home = () => {
	const { setAlert, setAlertMsg } = useGlobalStates();
	const [playVideo, setPlayVideo] = useState(false);

	const copyTextOnClick = (textToCopy) => {
		navigator.clipboard
			.writeText(textToCopy)
			.then(() => {
				setAlert("success");
				setAlertMsg("Copied!");
				console.log(textToCopy);

				setTimeout(() => {
					setAlert(false);
				}, 1000);
			})
			.catch((error) => {
				setAlert("error");
				setAlertMsg("Xatolik yuz berdi!");

				setTimeout(() => {
					setAlert(false);
				}, 1000);
			});
	};

	// Usage example
	const handleCopyAddress = () => {
		const addressToCopy = document.querySelector(".copy-address").textContent;
		copyTextOnClick(addressToCopy);
	};

	const handleCopyNumber = () => {
		const numberToCopy = document.querySelector(".copy-number").textContent;
		copyTextOnClick(numberToCopy);
	};

	const handleCopyBankAccount = () => {
		const bankAccountToCopy =
			document.querySelector(".bank-account").textContent;
		copyTextOnClick(bankAccountToCopy);
	};

	useEffect(() => {
		// Auto-scroll from top to bottom
		const container = document.querySelector(".scroll-container");
		if (container) {
			const scrollHeight = container.scrollHeight - container.clientHeight;
			container.scrollTo({ top: scrollHeight, behavior: "smooth" });
		}
	}, []);

	return (
		<div className="scroll-container h-full sm:w-[550px] w-full overflow-y-auto bg-gradient-to-b from-gray-900 to-gray-800 text-white px-2 py-6 flex flex-col gap-2">
			{/* HEADER */}
			<div className="flex items-center justify-between bg-white/10 backdrop-blur-lg shadow-xl border border-white/20 rounded-2xl px-3 py-3">
				<div className="text-4xl">✂️</div>

				<div className="text-center">
					<h1 className="text-4xl font-extrabold tracking-wide">USTA</h1>
					<p className="text-xs text-gray-300 uppercase tracking-[0.25em]">
						Barbershop
					</p>
				</div>

				<div className="text-4xl">💈</div>
			</div>
			{/* VIDEO */}
			<div className="flex flex-col gap-3">
				{/* VIDEO BOX */}
				<div
					className="relative bg-white/10 backdrop-blur-lg shadow-xl border border-white/20 rounded-2xl overflow-hidden w-full"
					style={playVideo ? { aspectRatio: "9/16" } : { aspectRatio: "4/3" }}
				>
					<AnimatePresence>
						{/* SMALL THUMBNAIL (before play) */}
						{!playVideo && (
							<motion.div
								initial={{ opacity: 0, scale: 0.8 }}
								animate={{ opacity: 1, scale: 1 }}
								exit={{ opacity: 0, scale: 0.85 }}
								transition={{ duration: 0.4, ease: "easeOut" }}
								className="absolute inset-0 flex flex-col items-center justify-center cursor-pointer"
								onClick={() => setPlayVideo(true)}
							>
								{/* SMALL THUMBNAIL */}
								<motion.img
									src="/imgs/thumbnail.jpg"
									alt="Thumbnail"
									className="rounded-xl shadow-lg object-cover"
									initial={{ scale: 0.9 }}
									animate={{ scale: 1 }}
									transition={{ duration: 0.4 }}
								/>

								{/* Play Button */}
								<motion.div
									className="absolute flex items-center justify-center"
									initial={{ opacity: 0, scale: 0.8 }}
									animate={{ opacity: 1, scale: 1 }}
									transition={{ delay: 0.1 }}
								>
									<div className="bg-black/60 rounded-full p-4 backdrop-blur-md shadow-xl">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											className="h-10 w-10 text-white"
											fill="currentColor"
											viewBox="0 0 24 24"
										>
											<path d="M8 5v14l11-7z" />
										</svg>
									</div>
								</motion.div>
							</motion.div>
						)}

						{/* FULL VIDEO ONCE CLICKED */}
						{playVideo && (
							<motion.iframe
								key="videoPlayer"
								initial={{ opacity: 0 }}
								animate={{ opacity: 1 }}
								transition={{ duration: 0.5 }}
								className="w-full h-full rounded-2xl"
								src="https://www.youtube.com/embed/iXgwfsb1OVw?autoplay=1"
								title="YouTube Shorts Vertical Video"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
								allowFullScreen
							/>
						)}
					</AnimatePresence>
				</div>

				<div className="bg-white/10 backdrop-blur-lg shadow-xl border border-white/20 rounded-2xl px-5 py-3 flex justify-between text-gray-200 font-semibold">
					<span>Ish Vaqti</span>
					<span>10:00 ~ 22:00</span>
				</div>
			</div>

			{/* ADDRESS & CONTACT */}
			<div className="flex flex-col gap-2 mb-8">
				<div
					onClick={handleCopyAddress}
					className="bg-white/10 copy-address backdrop-blur-xl shadow-xl border border-white/20 rounded-2xl px-5 py-3 text-gray-200"
				>
					경북 경산시 둥지로 84-1 (임당동 571-10)
				</div>

				<div className="bg-white/10 backdrop-blur-xl shadow-xl border border-white/20 rounded-2xl px-5 py-3 flex justify-between text-gray-200 font-semibold">
					<span className="copy-number" onClick={handleCopyNumber}>
						010-4619-5515
					</span>
					<span>053-813-5515</span>
				</div>

				<div
					onClick={handleCopyBankAccount}
					className="bg-white/10 bank-account backdrop-blur-xl shadow-xl border border-white/20 rounded-2xl px-5 py-3 text-gray-200"
				>
					국민 010-4619-5515 Numonov J.
				</div>

				{/* SOCIAL ICONS */}
				<div className="flex mt-3 w-full justify-between gap-3">
					<a
						href="https://t.me/uz_barber_korea"
						target="_blank"
						rel="noreferrer"
						className="flex flex-col items-center bg-white/10 backdrop-blur-xl border border-white/20 rounded-xl p-2 w-10 sm:w-14 sm:p-3"
					>
						<BiLogoTelegram className="text-2xl text-blue-400" />
					</a>

					<a
						href="https://www.instagram.com/usta.barbershop"
						target="_blank"
						rel="noreferrer"
						className="flex flex-col items-center bg-white/10 backdrop-blur-xl border border-white/20 rounded-xl p-2 w-10 sm:w-14 sm:p-3"
					>
						<GrInstagram className="text-2xl text-pink-400" />
					</a>

					<a
						href="https://www.tiktok.com/@uz_barber_korea"
						target="_blank"
						rel="noreferrer"
						className="flex flex-col items-center bg-white/10 backdrop-blur-xl border border-white/20 rounded-xl p-2 w-10 sm:w-14 sm:p-3"
					>
						<FaTiktok className="text-2xl" />
					</a>

					<a
						href="tel:010-4619-5515"
						target="_blank"
						rel="noreferrer"
						className="flex flex-col items-center bg-white/10 backdrop-blur-xl border border-white/20 rounded-xl p-2 w-10 sm:w-14 sm:p-3"
					>
						<FaPhoneAlt className="text-2xl text-green-400" />
					</a>

					<a
						href="https://kko.to/Tl-RJgNbEk"
						target="_blank"
						rel="noreferrer"
						className="flex flex-col items-center bg-white/10 backdrop-blur-xl border border-white/20 rounded-xl p-2 w-10 sm:w-14 sm:p-3"
					>
						<FaMapMarkedAlt className="text-2xl text-yellow-400" />
					</a>

					<a
						href="https://t.me/usta_2019"
						target="_blank"
						rel="noreferrer"
						className="flex flex-col items-center bg-white/10 backdrop-blur-xl border border-white/20 rounded-xl p-2 w-10 sm:w-14 sm:p-3"
					>
						<FaUserCheck className="text-2xl text-purple-400" />
					</a>
				</div>
			</div>
		</div>
	);
};

export default Home;
